import { Box, Table, Tbody, Td, Text, Th, Thead, Tr } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import {  InputGroup } from "react-bootstrap";

// import "antd/dist/antd.css";
import Form from "react-bootstrap/Form";

import { formatAmountInINR } from "jsFunctions/formatAmountInINR";
import {  calculateTdsAmount } from "./helperFunction";

const PurchaseItemTds = ({
  itemList, 
  handleUpdateItemField,
  updateTdsAmount,
  tdsAmount,
  isTdsPo
})=>{

  const [itemData, setItemData] = useState([])

  useEffect(()=>{
    setItemData(itemList);
    if(itemList && itemList?.length){
      const totalTds = calculateTdsAmount(itemList)
      updateTdsAmount(totalTds)

    }
  },[itemList])

 
    return (
      <>
        <Box className="item-table-label mt-1">
          <span className="lable-text">Item Table</span>
        </Box>
        <div className="ember-view">
          <Table className="line-item-table line-item-table-light">
            <Thead className="line-item-header bill-items">
              <Tr>
              <Th className="line-item-column over-flow col-number">
                  No.
                </Th>
                <Th className="line-item-column over-flow  tds-desc-us">
                  Name
                </Th>
                <Th className="line-item-column text-end tds-item-rate ">Amount</Th>

                <Th className="line-item-column  text-end tds-item-percentage" >
                  TDS Percentage (%)
                </Th>
                <Th className="line-item-column  text-end tds-amount-us">
                  TDS Amount
                </Th>
              </Tr>
            </Thead>
            <Tbody className="ember-view line-item-body">
              {itemData && itemData?.length ? itemData?.map((item,i)=>{
                return (
                  <Tr className="ember-view line-item bill-items new-line-item">
                    <Td className="ember-view line-item-column item-details col-number"><Text className="item-number">{i + 1}</Text></Td>

                    <Td className="ember-view line-item-column item-details tds-desc-us">
                    {item?.slItm?._id &&
                    <Box className="item-content ">
                    <div className="name">
                    <Box className="name-action" display="flex">
                          <Text className="label">{item?.slItm?.name}</Text>
                    </Box>
                    </div>
                    <div className="item-tratment">
                          <Text className="type ">{item?.slItm?.typ}</Text>
                          <Text display="flex" className="itemcode">{item?.slItm?.typ === 'goods'?'HSN':'SAC'} Code: 
                            <span className="hsnvalue">{item?.slItm?.typ === 'goods' ? item?.slItm?.hCd: item?.slItm?.sCd} </span>
                          </Text>
                      </div>
                    </Box>
                    }
                    </Td>
                    <Td className="ember-view line-item-column text-end tds-item-rate">
                     <Text className="label mx-2 mt-2">{formatAmountInINR(item?.amt || 0)}</Text>
                    </Td>
                    <Td className="ember-view line-item-column tds-item-percentage">
                      <InputGroup className="input-group">
                    <Form.Control
                        type="number"
                        name="tdsPercentage"
                        value={item?.tdsPrc}
                        onChange={(e)=>{handleUpdateItemField(e?.target?.value,'tdsPercentage',i)}}
                        className={`ember-text-field text-end ember-view form-control tds-percentage-field ${isTdsPo ? 'disabled-field':''}`}
                        placeholder=""
                        disabled={isTdsPo}
                        min={0}
                        max={100}
                        step="1"
                      />
                        <InputGroup.Text>
                          <span className="rupee-symbol">%</span>{" "}
                        </InputGroup.Text>
                        </InputGroup>
                    </Td>
                    <Td className="ember-view line-item-column  tds-amount-us ">
                    <Text className="label text-end mx-2 mt-2">{formatAmountInINR(item?.tlAmt || 0)}</Text>
                    </Td>
                  </Tr>
                );
              }):null}
              <Tr>
                <Td></Td>
                <Td></Td>
                <Td></Td>
                <Td className="text-end total-label border-bottom">Total TDS</Td>
                <Td className="text-end total-label border-bottom">{formatAmountInINR(tdsAmount || 0)}</Td>
              </Tr>
            </Tbody>
          </Table>
         
        </div>
        
      </>
    );
}

export default PurchaseItemTds;